import axios from "axios";
import { Auth } from "aws-amplify";
import { triggerSignOut } from "./authBridge";

const axiosHandler = axios.create({
  withCredentials: true,
  headers: {
    Accept: "application/json",
  },
  xsrfCookieName: "csrftoken",
  xsrfHeaderName: "X-CSRFToken",
});

// Add a flag to track if we're already in the login process
let isAuthenticating = false;

axiosHandler.interceptors.request.use(
  async (config) => {
    // Don't try to get a token if we're already in the login process
    if (!isAuthenticating) {
      try {
        // Try to get the current session
        const session = await Auth.currentSession();
        localStorage.setItem(
          "accessToken",
          session.getAccessToken().getJwtToken(),
        );
      } catch (error) {
        // Only try auto-login if we're not already on the login page and not already authenticating
        if (window.location.pathname !== "/" && !isAuthenticating) {
          isAuthenticating = true;

          try {
            // throw new Error("FORCED ERROR FOR TESTING"); // For testing auto-login failure
            await Auth.federatedSignIn({ customProvider: "FPGlobalSSO" });
            // This will redirect, so the following code won't execute until after redirect back
            const newSession = await Auth.currentSession();
            localStorage.setItem(
              "accessToken",
              newSession.getAccessToken().getJwtToken(),
            );
          } catch (loginError) {
            console.error("Auto-login failed:", loginError);
            console.warn(
              "Auto-login failed: Triggering Forced SignOut",
              loginError,
            );
            triggerSignOut();
          } finally {
            isAuthenticating = false;
          }
        }
      }
    }

    const token = localStorage.getItem("accessToken");

    config.headers["X-App-Identifier"] = "PORTAL";
    config.headers["X-App-Name"] = "FreightPlus One";
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

// Add response interceptor to handle 401s without auto-redirects
axiosHandler.interceptors.response.use(
  (response) => response,
  (error) => {
    // Don't automatically redirect on auth errors
    return Promise.reject(error);
  },
);

export default axiosHandler;
